import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { EasyModal, EasyIcon, EditPage, EditTreeContext } from 'src/components'

type Props = {
  config: ButtonConfig
}

const AddBtnDiffLevel = (props: Props) => {
  const tree = useContext(EditTreeContext)

  const formData = useMemo(() => {
    // 新增下级时，要把当前节点的 formId 当作 parentFormId
    return { parentFormId: tree.selectedNodes[0]?.ID }
  }, [tree.selectedNodes[0]?.ID])

  const formCode = tree.treeConfig.Nav_Form?.CODE
  const { LABEL, ICON, WIDTH } = props.config
  return (
    <EasyModal
      modal={{ title: formCode, width: WIDTH }}
      slot={<EasyIcon title={LABEL} type={ICON} defaultIcon='PlusSquareOutlined' />}
      onClose={() => tree.getTreeData(tree.selectedNodes[0])}
    >
      <EditPage formCode={formCode} formData={formData} />
    </EasyModal>
  )
}

export default AddBtnDiffLevel